"use client";
import { UseFormReturn } from "react-hook-form";
import { RESERVE_TEXTS } from "@/features/reserve/utils/utils-reserve";
import { FormControl, FormField, FormItem, FormMessage } from "@/ui/form";
import { Input } from "@cmp-src/primitives/input";
import { cn } from "@gettactic/helpers";
import { InputLabel } from "../components/InputLabel/InputLabel";
import { ReserveFieldDescription } from "@/features/reserve/components/ReserveFieldDescription/ReserveFieldDescription";
import React from "react";
import { DescriptionIcon } from "@gettactic/components/src/icons/TacticIcons/DescriptionIcon";
import { Button } from "@cmp-src/primitives/button";
type ReserveTitleProps = {
  form: UseFormReturn<any>;
  withDescription?: boolean;
  showLabel?: boolean;
};

export function ReserveFieldTitle({
  form,
  withDescription,
  showLabel = true
}: ReserveTitleProps) {
  const [notesOpened, setNotesOpened] = React.useState(false);
  return (
    <>
      <FormField
        control={form.control}
        name="title"
        render={({ field }) => (
          <FormItem>
            <FormControl>
              {/* real wrapper that owns the rainbow */}
              <div className=" rounded-md text-base ">
                {showLabel && <InputLabel htmlFor="title">Title</InputLabel>}
                <div className="flex items-stretch gap-2 ">
                  <div className="focus-ring-rainbow flex-1">
                    <Input
                      placeholder={RESERVE_TEXTS.addTitle}
                      className={cn(
                        "flex-1 focus:outline-none focus-visible:outline-none !border-none rounded-v2 bg-neutral-50"
                      )}
                      {...field}
                    />
                  </div>
                  {withDescription && (
                    <Button
                      type="button"
                      className="flex h-[42px] w-[47px] flex-shrink-0 items-center justify-center gap-[66px] rounded-lg border border-neutral-200 bg-white px-4 hover:bg-neutral-50 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2"
                      onClick={(e) => {
                        e.preventDefault();
                        setNotesOpened((s) => !s);
                      }}
                      variant="ghost"
                    >
                      <DescriptionIcon />
                    </Button>
                  )}
                </div>
                {withDescription && notesOpened && (
                  <div className="mt-3">
                    <ReserveFieldDescription form={form} />
                  </div>
                )}
              </div>
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </>
  );
}
